import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { getGuarantorRoles } from '../../requests/getGuarantorRoles';

export const useGuarantorRoles = (
  uuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();
  const { data, ...rest } = useQuery<NonPaginatedResponse<any[]> | undefined>({
    queryKey: [PLUGIN_BASE_PATH, 'guarantor-roles', uuid],
    queryFn: () => getGuarantorRoles(constructGet, uuid),
    enabled: !!uuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'roles'), ...rest };
};
